import { useState, useEffect } from 'react';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY;

async function fetchDocuments(courseId) {
  const response = await fetch(
    `${SUPABASE_URL}/rest/v1/course_documents?course_id=eq.${courseId}&deleted=eq.false&select=*&order=uploaded_at.asc`,
    { headers: { 'apikey': SUPABASE_KEY, 'Authorization': 'Bearer ' + SUPABASE_KEY } }
  );
  return response.json();
}

export default function StudentDocuments({ session, course, enrolment, onBack }) {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDocuments(course.id).then(data => setDocuments(Array.isArray(data) ? data : [])).finally(() => setLoading(false));
  }, [course.id]);

  if (loading) return <div style={styles.wrap}><div style={styles.muted}>Loading...</div></div>;

  return (
    <div style={styles.wrap}>
      <div style={styles.content}>
        <h2 style={styles.heading}>Documents</h2>

        {documents.length === 0 && (
          <div style={styles.muted}>No documents available.</div>
        )}

        <div style={styles.list}>
          {documents.map(doc => (
            <div key={doc.id} style={styles.item}>
              <div style={styles.itemLeft}>
                <span style={styles.docIcon}>DOC</span>
                <div style={styles.docTitle}>{doc.title}</div>
              </div>
              {doc.drive_file_id ? (
                
                  <a href={`https://drive.google.com/uc?export=download&id=${doc.drive_file_id}`}
                  target="_blank"
                  rel="noreferrer"
                  style={styles.downloadBtn}
                >
                  ↓ Download
                </a>
              ) : (
                <span style={styles.processing}>Processing...</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

const styles = {
  wrap: { minHeight: 0, background: 'transparent' },
  content: { padding: 0, maxWidth: 'none', margin: 0 },
  muted: { color: '#627d98', fontSize: '14px' },
  heading: { margin: '0 0 20px', fontSize: '26px', color: '#243b53', fontWeight: '700' },
  list: { display: 'flex', flexDirection: 'column', gap: '8px' },
  item: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    padding: '14px 16px', background: 'white', border: '1px solid #d9e2ec',
    borderRadius: '6px', gap: '12px'
  },
  itemLeft: { display: 'flex', alignItems: 'center', gap: '12px', flex: 1 },
  docIcon: { width: '36px', height: '36px', border: '1px solid #d9e2ec', background: '#f7f8fa', color: '#627d98', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '9px', fontWeight: '800', letterSpacing: '0.06em', flexShrink: 0 },
  docTitle: { fontWeight: '600', fontSize: '15px', color: '#243b53' },
  downloadBtn: {
    background: '#2f6f9f', color: 'white', borderRadius: '5px',
    padding: '8px 14px', fontSize: '13px', textDecoration: 'none',
    fontWeight: '600', flexShrink: 0
  },
  processing: { fontSize: '13px', color: '#627d98', flexShrink: 0 }
};